import { Customer } from "../models/customer";
import { Constant } from "../services/constant";

export function getFullName(customer?: Customer): string {
  // Return an empty string 
  // if the customer's name is missing 
  // or if the customerId is -1 (indicating an unknown customer)
  if (!customer?.Name || customer.Id == -1) {
    return "";
  }

  // If the customer is an organization, return the name
  if (customer.IsOrganisation) {
    return customer.Name;
  }

  // Handle Japanese customer format as  LastName + ' ' +  FirstName
  if (process.env.REACT_APP_COUNTRY_CODE === Constant.countryCodes.JP) {
    return `${customer.LastName ?? ''} ${customer.FirstName ?? ''}`.trim();
  }

  // "Name" is a variable processed on the backend as FirstName + ' ' + LastName
  return customer.Name;
}
